/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './braking-position-icon.module.css'

const propTypes = {
    eventSeverity: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48,
    eventSeverity: 'default'
}

/**
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const BrakingPositionIcon = props => {
    const { eventSeverity } = props
    return (
        <SvgIcon {...props} className={styles['braking-position-pin']}>
            <path
                className={styles['icon-foreground']}
                d={`M37.528,7.876c-3.459-3.435-8.236-5.561-13.511-5.561c-5.278,0-10.056,2.126-13.514,5.564
        c-3.459,3.436-5.598,8.185-5.598,13.43c0,5.246,2.144,9.996,5.603,13.434C13.967,38.18,24.017,46,24.017,46
        S34.07,38.177,37.53,34.739c3.459-3.439,5.598-8.186,5.598-13.431C43.128,16.063,40.988,11.314,37.528,7.876`}
            />
            <path
                className={styles[eventSeverity]}
                d={`M36.627,8.811c-3.228-3.206-7.686-5.19-12.611-5.19c-4.926,0-9.386,1.985-12.613,5.192
        c-3.228,3.207-5.225,7.64-5.225,12.535c0,4.896,2.001,9.33,5.23,12.539c3.228,3.207,12.608,10.506,12.608,10.506
        s9.384-7.301,12.613-10.51c3.228-3.21,5.225-7.64,5.225-12.535C41.854,16.452,39.857,12.02,36.627,8.811`}
            />
            <path
                className={styles['icon-foreground']}
                d={`M24.017,13.863c-3.561,0-6.447,2.887-6.447,6.447c0,3.561,2.887,6.447,6.447,6.447
        c3.561,0,6.447-2.886,6.447-6.447C30.464,16.749,27.577,13.863,24.017,13.863z`}
            />
            <path
                className={styles['icon-foreground']}
                d={`M16.397,26.577c-0.196,0-0.392-0.064-0.557-0.196c-0.104-0.085-2.569-2.106-2.569-6.072
        s2.464-5.987,2.569-6.071c0.385-0.308,0.949-0.247,1.259,0.138c0.308,0.385,0.248,0.946-0.135,1.256
        c-0.088,0.073-1.902,1.611-1.902,4.677c0,3.075,1.825,4.613,1.902,4.677c0.38,0.313,0.439,0.876,0.128,1.258
        C16.916,26.464,16.657,26.577,16.397,26.577z`}
            />
            <path
                className={styles['icon-foreground']}
                d={`M31.633,26.577c-0.262,0-0.522-0.115-0.699-0.335c-0.309-0.386-0.247-0.95,0.138-1.259
        c0.073-0.06,1.898-1.599,1.898-4.674s-1.825-4.613-1.902-4.677c-0.38-0.313-0.439-0.876-0.128-1.258
        c0.311-0.382,0.87-0.442,1.253-0.136c0.104,0.084,2.569,2.105,2.569,6.071s-2.464,5.987-2.569,6.071
        C32.028,26.513,31.83,26.577,31.633,26.577z`}
            />
        </SvgIcon>
    )
}

BrakingPositionIcon.defaultProps = defaultProps
BrakingPositionIcon.propTypes = propTypes

export { BrakingPositionIcon }
